export function isObject(x: unknown): boolean {
  return typeof x === 'object' && !Array.isArray(x) && x !== null;
}
